import { render, staticRenderFns } from "./HelpView.vue?vue&type=template&id=e28cf0f2&scoped=true"
import script from "./HelpView.vue?vue&type=script&lang=js"
export * from "./HelpView.vue?vue&type=script&lang=js"
import style0 from "./HelpView.vue?vue&type=style&index=0&id=e28cf0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28cf0f2",
  null
  
)

export default component.exports